import FieldType from '@/ecm/variables/FieldType'
import ListItem from '@/ecm/models/document/ListItem'
import StringValidation from '@/ecm/models/document/validation/StringValidation'
import NumericValidation from '@/ecm/models/document/validation/NumericValidation'
import DateTimeValidation from '@/ecm/models/document/validation/DateTimeValidation'

export default class Field {
    constructor(dto, fieldList) {       
        this.defFieldId = 0
        this.type = 0
        this.isReadOnly = false
        this.isVisible = false
        this.isRequired = false
        this.isUnique = false
        this.title = ''
        this.value = ''
        this.defaultValue = ''
        this.code = ''
        this.observations = ''
        this.listElements = []
        this.validations = null
        this.fieldsOnWhichDepends = []
        this.fieldsThatDependOn = []
        this.internalTableId = null
        this.multiValue = false
        this.changed = false;
        this.isNewValueFormat = false
        this.valueDate = null;
        this.valueNumber = null;
        this.valueString = '';
        this.optionsValue = [];

        if (dto) {
            this.isReadOnly = dto.IsReadOnly
            this.isVisible = dto.IsVisible
            this.isRequired = dto.IsRequired
            this.isUnique = dto.IsUnique
            this.title = dto.Title
            this.defaultValue = dto.DefaultValue
            this.value = dto.Multivalue ? (dto.Value || '').split(',').filter(x => x) : dto.Value || ''
            this.code = dto.Code
            this.type = dto.Type
            this.defFieldId = dto.DefFieldID
            this.observations = dto.Observations
            this.validations = this.getValidations(dto.Validations)
            this.listElements = dto.ListElements ? dto.ListElements.map(function (dto) { return new ListItem(dto) }) : null
            this.internalTableId = dto.InternalTableID
            this.multiValue = dto.Multivalue
            this.fieldsOnWhichDepends = [...new Set(dto.RelatedFieldsCodes)]
            this.isNewValueFormat = dto.IsNewValueFormat
            this.valueDate = dto.ValueDate
            this.valueNumber = dto.ValueNumber
            this.valueString = dto.ValueString
            this.optionsValue = dto.OptionsValue

            // For linked list
            if (fieldList) {
                var relatedFields = fieldList.filter(f => f.Code != this.code &&
                    f.RelatedFieldsCodes.includes(this.code))

                relatedFields.forEach(relatedField => {
                    this.fieldsThatDependOn.push(relatedField.Code)
                })
            }

            //Default value
            if (!this.value && this.defaultValue) {
                this.value = this.defaultValue;
            }
        }
    }

    getValidations(validationsDto) {
        if (this.type == FieldType.String) {
            return new StringValidation(validationsDto)
        }
        if (this.type == FieldType.DateTime) {
            return new DateTimeValidation(validationsDto)
        }
        if (this.type == FieldType.Numeric) {
            return new NumericValidation(validationsDto)
        }

        return null
    }

    toDto() {
        return {
            Title: this.title,
            Value: Array.isArray(this.value) ? this.value.filter(x => x).join(',') : this.value,
            Code: this.code,
        }
    }
}
